import { render } from "./NewReminder.vue?vue&type=template&id=d20125e4&scoped=true"
import script from "./NewReminder.vue?vue&type=script&lang=js"
export * from "./NewReminder.vue?vue&type=script&lang=js"

import "./NewReminder.vue?vue&type=style&index=0&id=d20125e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d20125e4"]])

export default __exports__